import styled from 'styled-components';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { DEACTIVATED, REMOVED } from '../constants/activation-status';
import { jsx as _jsx } from "react/jsx-runtime";
const ActivationStatusTag = styled.div.withConfig({
  displayName: "OwnerActivationStatusTag__ActivationStatusTag",
  componentId: "sc-17ajh52-0"
})(["display:inline-block;"]);
const OwnerActivationStatusTag = ({
  activationStatus
}) => {
  switch (activationStatus) {
    case DEACTIVATED:
      return /*#__PURE__*/_jsx(ActivationStatusTag, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          className: "p-left-1",
          message: "routing-ui.reassignment.activationStatusDeactivated"
        })
      });
    case REMOVED:
      return /*#__PURE__*/_jsx(ActivationStatusTag, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          className: "p-left-1",
          message: "routing-ui.reassignment.activationStatusRemoved"
        })
      });
    default:
      return null;
  }
};
OwnerActivationStatusTag.displayName = 'OwnerActivationStatusTag';
export default OwnerActivationStatusTag;